<template lang="pug">
  .page.page_offset_top.page_offset_bottom
    .page-meta
      .container
        .page-meta__inner.page-meta__inner_top
          breadcrumbs
          social.page-meta__social-list(theme="blue")
    .page-contacts
      .container
        h1.title.title_size_l.text_center.page-contacts__title Свяжитесь с нами
        p.text_center.page-contacts__desc We’re happy to&nbsp;answer any questions you may have, just send&nbsp;us a&nbsp;message via our in-app support chat.
        .page-contacts__row
          .page-contacts__col
            .map-info
              .map-info__content
                h3.title.title_size_s.text_center.text_upper.page-contacts__subtitle Контактная информация
                p.text_center.page-contacts__info-text 115114, г.&nbsp;Москва, Павелецкая набережная, 2, строение&nbsp;15А, бизнес-центр «Loft&nbsp;Ville»
                p.text_center.page-contacts__info-text Телефон: #[a(href="tel:+74952343300") +7 495 234 33 00]#[br] Тех. поддержка: #[a(href="mailto:support@belkacar.ru") support@belkacar.ru]
              .map-info__map
          .page-contacts__col
            .cv-card.page-contacts__cv-card
              h3.title.title_size_s.text_center.text_upper.cv-card__title Контакты для корпоративных клиентов:
              .cv-card__row
                .cv-card__image
                  img(src="/static/img/emuradova.jpg", alt="Елена Мурадова")
                .cv-card__content
                  p.cv-card__name Елена Мурадова
                  p.cv-card__role Управляющий партнёр
                  p.cv-card__contact: a(href="mailto:emuradova@belkacar.ru") emuradova@belkacar.ru
            .cv-card.page-contacts__cv-card
              h3.title.title_size_s.text_center.text_upper.cv-card__title Контакты для корпоративных клиентов:
              .cv-card__row
                .cv-card__image
                  img(src="/static/img/emakarova.jpg", alt="Екатерина Макарова")
                .cv-card__content
                  p.cv-card__name Екатерина Макарова
                  p.cv-card__role Управляющий партнёр
                  p.cv-card__contact: a(href="mailto:emakarova@belkacar.ru") emakarova@belkacar.ru

</template>

<script>
import Social from './../components/Social'

export default {
  name: 'Contacts',
  components: { Social },
  data () {
    return {

    }
  },
  created () {
    this.map()
  },
  methods: {
    map () {
      console.log('map')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Contacts.vue